export interface YieldHistory {
  SortId: SortId;
  Value: number;
  ValueDate: Date;
  Category: string;
}

export enum SortId {
  Index = 1,
  Customer,
}
